import { computed, ref } from "vue";

import uniqBy from "lodash/uniqBy";
import { defineStore } from "pinia";

import type { SendApplicationEmailModalData } from "@/models/emails";
import type { MultiSelectOption } from "@/models/options";

const getDefaultModalData = (): SendApplicationEmailModalData => ({
  applications: [],
  customizations: [],
  email_addresses: [],
  templates: [],
  reply_to_recipients: [],
});

const useEmailsStore = defineStore("emails", () => {
  const modalData = ref<SendApplicationEmailModalData>(getDefaultModalData());

  const recipientApplicationsOptions = computed(() =>
    modalData.value?.applications?.flatMap(
      ({ owners }) =>
        owners?.map((owner) => ({
          id: String(owner.personal_info_id),
          name: owner.email_address,
        })) ?? []
    )
  );

  const recipientReplyToOptions = computed<MultiSelectOption[]>(
    () =>
      modalData.value?.reply_to_recipients?.map((item) => ({
        id: String(item.personal_info_id),
        name: item.email_address,
      })) ?? []
  );

  const recipientOptions = computed<MultiSelectOption[]>(() => {
    return uniqBy(
      [...recipientApplicationsOptions.value, ...recipientReplyToOptions.value],
      "id"
    );
  });

  return {
    modalData,
    recipientOptions,
    recipientApplicationsOptions,
  };
});

export default useEmailsStore;
